import Basic from '@/layouts/Basic';

const router = [
    {
        path: '/error',
        component: Basic,
        meta: { auth: true },
        children: [
            {
                path: '/404',
                name: '404',
                component: () => import('@/views/errors/404'),
                meta: { title: 'Página não encontrada' },
            },
            {
                path: '/403',
                name: '403',
                component: () => import('@/views/errors/403'),
                meta: { title: 'Acesso não autorizado' },
            },
        ],
    },
    {
        path: '/device-blocked',
        component: Basic,
        children: [
            {
                path: '',
                name: 'device-blocked',
                component: () => import('@/views/errors/device_blocked'),
                meta: { title: 'Acesso não autorizado' },
            },
        ],
    },
];

export default router;
